module.exports = __webpack_public_path__ + "img/process.965f0435.png";